export default __webpack_public_path__ + "static/media/notificationBell.12134b62.svg";